import React from 'react';
import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';

let bugsnagClient;
let ErrorBoundary;

// Only initialize Bugsnag in non-test environments
if (process.env.NODE_ENV !== 'test') {
    bugsnagClient = bugsnag({
        apiKey: process.env.REACT_APP_BUGSNAG_API_KEY || 'your-bugsnag-api-key-here',
        appVersion: process.env.REACT_APP_VERSION,
        releaseStage: process.env.NODE_ENV,
        enabledReleaseStages: ['production', 'staging'],
        onError: function(event) {
            // Prevent reporting if no valid API key
            if (
                !process.env.REACT_APP_BUGSNAG_API_KEY ||
                process.env.REACT_APP_BUGSNAG_API_KEY === 'your-bugsnag-api-key-here'
            ) {
                return false;
            }
        },
    });
    bugsnagClient.use(bugsnagReact, React);
    ErrorBoundary = bugsnagClient.getPlugin('react');
} else {
    // Mock bugsnagClient for test environment
    bugsnagClient = {
        notify: () => {},
        leaveBreadcrumb: () => {},
        user: null,
    };
    // Mock ErrorBoundary for test environment
    ErrorBoundary = ({ children }) => children;
}

export { bugsnagClient, ErrorBoundary };
